export default __webpack_public_path__ + "static/media/Location.b92ad488.svg";